import { ConnectingAirportsOutlined } from "@mui/icons-material";
import React, { useEffect, useState, memo } from "react";
import { EditText, EditTextarea } from "react-edit-text";
import "react-edit-text/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestion, updateSelectedComponentType } from "../../../../redux/slices/userActivity";

const maxQuestionChar = 100;

function Question({ question, style }) {
  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen } = useSelector((state) => state.preview);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    if (e.target.value.length > maxQuestionChar) return;
    dispatch(updateQuestion({ selectedActivityIdx: selectedUserActivity, question: e.target.value }));
  };

  useEffect(() => {
    dispatch(
      updateSelectedComponentType({
        type: "slide",
        name: "container",
      })
    );
  }, []);

  const handleClick = () => {
    dispatch(
      updateSelectedComponentType({
        type: "text",
        name: "question",
      })
    );
  };

  const reset = () => {
    dispatch(
      updateQuestion({
        selectedActivityIdx: selectedUserActivity,
        question: "Type your question here",
      })
    );
  };
  return (
    <div className="question" onClick={handleClick} style={style !== undefined ? style.questionContainer : {}}>
      <EditTextarea
        id="question-input-field"
        value={question}
        className="editable_text__question"
        onEditMode={() => setTimeout(() => document.querySelector("#question-input-field").select(), 100)}
        onBlur={() => {
          question === "" && reset();
        }}
        onClick={handleClick}
        style={{
          ...style.question,
          display: "block",
          backgroundColor: "transparent",
          overflowY: "visible",
          wordBreak: "break-word",
          outline: "none",
          border: "0",
        }}
        onChange={(e) => handleChange(e)}
        readonly={previewModalOpen ? true : false}
      />
    </div>
  );
}

export default memo(Question);
